export const adminLinks = [
    {
        label: "Задачи",
        dropdown: [
            { label: "Обучение ", to: "/program/" },
            { label: "Конструктор ", to: "/admin/constructor/", globe: true },
            { label: "Импорт с Lichess ", to: "/admin/puzzle-import/", globe: true },
            { label: "Темы обучения", to: "/admin/site-settings/themes/", globe: true },
            { label: "Координаты ", to: "/coordinate/" },
            { label: "Список Задач ", to: "", disabled: true, globe: true },
        ],
    },
    {
        label: "Звания",
        to: "/ranks/"
    },
    {
        label: "Магазин",
        dropdown: [
            { label: "Товары", to: "/shop/" },
            { label: "Мои заказы", to: "/orders/" },
            { label: "Управление товарами", to: "/admin/products/", globe: true },
            { label: "Управление заказами", to: "/admin/shop-orders/", globe: true },
            { label: "Статистика магазина", to: "/admin/shop-stats/", globe: true },
        ],
    },
    {
        label: "Челленджи",
        dropdown: [
            { label: "Участвовать ", to: "/challenges/" },
            { label: "Список челленджей ", to: "/admin/challenges/", globe: true },
            { label: "Создать челлендж ", to: "/challenge/create/", globe: true },
            { label: "Автоматические челленджи ", to: "/admin/auto-challenges/", globe: true },
        ],
    },
    {
        label: "Админка",
        dropdown: [
            { label: "Список пользователей ", to: "/users/", globe: true },
            { label: "Операции с пешкариками ", to: "/admin/transactions/all/", globe: true },
            { label: "Управление пользователями ", to: "/admin/impersonation/", globe: true },
            { label: "Настройки", to: "/admin/site-settings/", globe: true },
            { label: "Список платежей ", to: "", disabled: true, globe: true },
            { label: "Турниры клуба ", to: "/tournaments/"},
            { label: "Уведомления ", to: "/admin/notifications", globe: true },
            { label: "Инструкции ", to: "/instructions/", globe: true },
        ],
    },
    {
        label: "Ачивки",
        dropdown: [
            { label: "Управление ачивками", to: "/admin/achievements", globe: true },
            { label: "История ачивок", to: "", disabled: true, globe: true },
            { label: "Ачивки за день", to: "", disabled: true, globe: true },
            { label: "История серий ачивок", to: "", disabled: true, globe: true },
            { label: "Текущие серии ачивок", to: "/admin/streaks/", globe: true },
        ],
    },
    { label: "Техподдержка", isSentryFeedback: true },
];
